<!-- set slide route animation -->
<div
  [@routeAnimations]="routerOutlet && routerOutlet.activatedRouteData && routerOutlet.activatedRouteData['animation']">
  <router-outlet #routerOutlet="outlet"></router-outlet>
</div>
<!-- 
  The [@routeAnimations] attribute is used to set the animation for the router outlet. The value of this attribute is determined by the routerOutlet and activatedRouteData properties. The routerOutlet property is used to get a reference to the router outlet, and the activatedRouteData property is used to get a reference to the route data associated with the current route. The value of the 'animation' property of this route data will be used as the value for [@routeAnimations]. This allows different animations to be set for different routes.
 -->
